/**
 * Remove timestamp suffix from name for display.
 * Pattern: _1234567890 (10-digit unix timestamp at end)
 */
export function cleanName(name: string | null | undefined): string {
  if (!name) return '';
  return name.replace(/_\d{10}$/, '');
}
